'use client';

import Image, {
  ImageProps,
  ImageLoaderProps,
  StaticImageData,
} from 'next/image';
import { useClientEnvContext } from '@/contexts';

const QUALITY = 75;

const basketLoader = ({ src, width, quality }: ImageLoaderProps) => {
  const {
    WB_STATIC_URL,
    APP_STATIC_NAMESPACE,
    CI_COMMIT_TAG: APP_VERSION,
  } = useClientEnvContext();

  const assetPrefix = APP_VERSION
    ? `${WB_STATIC_URL}/${APP_STATIC_NAMESPACE}/latest`
    : '';

  const isAbsolute = src.startsWith('http') || src.startsWith('//');
  const finalSrc = isAbsolute ? src : `${assetPrefix}${src}`;

  return `${finalSrc}?w=${width}&q=${quality || QUALITY}`;
};

export const BasketImage = (
  props: ImageProps & { src: string | StaticImageData },
) => {
  const imageSrc = typeof props.src === 'string' ? props.src : props.src.src;

  return (
    <Image {...props} loader={basketLoader} loading="lazy" src={imageSrc} />
  );
};
